// Каталог редактируемых текстов игры (Фаза 6). Тянется с бэка (GET /messages?lang=<код>), правится из админки.
// Компоненты подставляют значения через msg('раздел.ключ', 'фолбэк'); при недоступности сервера — фолбэк.
// Каталог ЯЗЫКОЗАВИСИМЫЙ: при смене языка в настройках перезапрашиваем ветку нужной локали (см. PageOptions).
import { currentLocale } from '@/i18n';

const state = {
  catalog: null, // { battle: { surrender_btn: '...', ... }, ... } или null (до загрузки/при ошибке)
  lang: null,    // язык уже загруженного каталога (чтобы компоненты не тянули его повторно)
};

const mutations = {
  SET_MESSAGES: (state, payload) => {
    state.catalog = (payload && payload.catalog) || {};
    state.lang = (payload && payload.lang) || null;
  },
};

const actions = {
  FETCH_MESSAGES: async (context, inst) => {
    const lang = currentLocale();
    // каталог этого языка уже в сторе — второй раз не тянем (после смены языка lang не совпадёт → запрос уйдёт)
    if (context.state.catalog && context.state.lang === lang) return;
    try {
      const r = await inst.axios.get('/messages', { params: { lang } });
      context.commit('SET_MESSAGES', { catalog: r.data || {}, lang });
    } catch (e) { /* сеть недоступна — оставляем как есть, компоненты используют зашитые фолбэки */ }
  },
};

// Достать текст по пути 'раздел.ключ' из каталога (или fallback). Экспорт — для использования в компонентах.
export function pickMessage(catalog, path, fallback) {
  if (!catalog) return fallback;
  let cur = catalog;
  for (const part of String(path).split('.')) {
    if (cur && typeof cur === 'object' && part in cur) cur = cur[part];
    else return fallback;
  }
  return (typeof cur === 'string' && cur) ? cur : fallback;
}

export default { state, mutations, actions };
